import React from 'react';
import styles from './InvestmentTeam.css';

import Card from '../../components/Card/Card';
import Carousel from '../../components/Carousel/Carousel';
import InvestmentTeamSlide from '../../components/Carousel/InvestmentTeamSlide';
import GqlQueryWrapper from '../../components/GqlQueryWrapper/GqlQueryWrapper';
import TablePreRender from '../../components/Table/Table.prerender';
import TitleWithDescription from '../../components/TitleWithDescription/TitleWithDescription';

import { investmentTeamUtil } from './util';

import { FUND_MANAGER, ETF_FUND_MANAGER } from './queries';

const InvestmentTeamCard = ({ ticker, etf }) => (
    <div className="investment-team-card">
        <Card>
            <GqlQueryWrapper
                query={etf ? ETF_FUND_MANAGER : FUND_MANAGER}
                variables={{ ticker }}
                dataFunc={investmentTeamUtil}
                placeholder={() => <TablePreRender height="250px" />}
            >
                {({ data: { data: slides } }) => (
                    <div className="container">
                        <TitleWithDescription title="Investment Team" />
                        {slides.length > 1 ? (
                            <Carousel>
                                {slides.map((slide) => (
                                    <div key={`profile-${slide.name}`}>
                                        <InvestmentTeamSlide
                                            {...slide}
                                            ticker={ticker}
                                        />
                                    </div>
                                ))}
                            </Carousel>
                        ) : (
                            <InvestmentTeamSlide
                                {...slides[0]}
                                ticker={ticker}
                            />
                        )}
                    </div>
                )}
            </GqlQueryWrapper>
        </Card>

        <style jsx>{styles}</style>
    </div>
);

export default InvestmentTeamCard;
